﻿$.getScript("/static/js/slick/slick.min.js");